/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ContentStudioQuestion } from './contentStudioQuestion';

/**
 * Output: Strategy questions based on the locked scope.
 */
export interface ContentStudioStage2Response {
  strategyQuestions: ContentStudioQuestion[];
  /** A brief summary of what is in and out of scope */
  scopeSummary: string;
}
